import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RefreshService {
  private readonly http: HttpClient;

  constructor() {
    this.http = new HttpClient(inject(HttpBackend));
  }

  public refresh(): Observable<unknown> {
    return this.http.post('/api/auth/refresh', null, { withCredentials: true, observe: 'response' });
  }
}
